define('third-party-apis/coral-talk/coral-talk',[
    'jquery',
    'underscore',
    'third-party-apis/base-third-party-api',
    'modules/global/userUtil',
    'utils',
    'pubsub',
    'modules/global/ad-free-redirect',
    'third-party-apis/firefly/firefly',
    'state'
],
function (
    $,
    _,
    BaseThirdPartyApi,
    UserUtil,
    Utils,
    PubSub,
    AdFreeRedirectCard,
    Firefly,
    StateManager
) {
    'use strict';

    /**
     * Library to handle calls to/from Coral Talk Comments service.
     * @author David Burke <dburke@gannett.com>
     */
    var CoralTalk = BaseThirdPartyApi.extend({
        initialize: function () {
            this._config = this.getApiSiteConfig('CORALTALKCOMMENTS');
            if (this._config && this._config.ENABLED) {
                var envPart = Utils.getNested(window.site_vars, 'site_env') === 'stage' ? '-stage' : '';
                this._gupLogin = Utils.getNested(window.site_vars, "gup", "gupui_path");
                this._cmPage = 'https://cm' + envPart + '.' + window.site_vars.base_url;
                this._storyUrl = 'https://www.' + window.site_vars.base_url + window.location.pathname;
                this._safeFrameOrigins = [
                    this._gupLogin,
                    this._cmPage
                ];
                this._loggedInViaEmbed = false;

                var pageInfo = StateManager.getActivePageInfo();
                this._trackingPrefix = pageInfo.contenttype + '|' + pageInfo.section_name + '|';

                if (this._config.REQUIRESMARKETACCESS) {
                    $('.coral-talk-subscribers-only').removeClass('hidden');
                }

                this._serviceUrl = Utils.getNested(window.site_vars, 'site_env') === 'stage' ?
                    'https://gannett.staging.coral.coralproject.net' :
                    'https://' + Utils.getNested(window.site_vars, 'site_key') + '.coral.coralproject.net';

                _.bindAll(this, '_onSafeFrameMsg');
            }

            BaseThirdPartyApi.prototype.initialize.call(this);
        },

        /**
         * Loads Coral Talk commenting script.
         * @private
         */
        _handleLoadScript: function () {
            if (!this._coralTalkPromise) {
                this._coralTalkPromise = $.Deferred(_.bind(function (defer) {
                    if (!this._config.ENABLED) {
                        defer.reject();
                        return;
                    }
                    $.ajax(this._serviceUrl + '/assets/js/embed.js',
                        {
                            cache: true,
                            data: {},
                            dataType: 'script'
                        }).always(_.bind(function () {
                            // even if the script loads, ad/script blockers may prevent Coral from becoming available
                            // if it's not available, fail the load so no future scripts fire/crash
                            if (window.Coral) {
                                this._initializeCoralTalk();
                                defer.resolve(window.Coral);
                            } else {
                                defer.reject();
                            }
                        }, this));
                }, this)).promise();
            }
            return this._coralTalkPromise;
        },

        /**
         * Initializes Coral Talk's Comments.
         * @private
         */
        _initializeCoralTalk: function () {
            this._scrollWrapComments = $('.util-bar-scroll-wrap-comments');
            this._coralTalkHeader = $('.coral-talk-header');
            this._coralTalkEmbedWrap = $('.coral-talk-embed-wrap');
            this._gupEmbed = $('.gup-embed');

            this._getUserResponse().then(_.bind(function (result) {
                var authToken = '';
                // Before we can load coral talk we'll need the users auth token if it exists.
                if (result.meta.isAuthenticatedInCurrentContext && result.response && result.response.user) {
                    this.$user = result.response.user;
                    authToken = !this._config.REQUIRESMARKETACCESS || this.$user.hasMarketAccess ?
                        result.response.user.coralJWT :
                        null;
                }

                if (this._loggedInViaEmbed) {
                    // The user has asynchronously logged in via the gup embed.
                    PubSub.trigger.apply(PubSub, ['user:statuschange', 'firefly', 'loggedIn', this.$user]);
                    var adFreeEntitlements =  Utils.getNested(window, 'site_vars', 'ad_free_entitlements');
                    if (this.$user && adFreeEntitlements.indexOf(this.$user.userLicenseType) > -1) {
                        new AdFreeRedirectCard();
                        return;
                    } else {
                        this._toggleCoralTalkAndGupEmbed();
                        this._loggedInViaEmbed = false;
                    }
                }

                // Create a new container that will receive the coral talk stream
                this._coralTalkEmbed = $('<div id="coral_thread"/>');
                this._coralTalkEmbedWrap.empty();
                this._coralTalkEmbedWrap.append(this._coralTalkEmbed);

                // Render coral talk comments
                window.Coral.createStreamEmbed({
                    id: "coral_thread",
                    autoRender: true,
                    rootURL: this._serviceUrl,
                    accessToken: authToken,
                    storyURL: this._storyUrl,
                    events: _.bind(this._registerCommentingLoginEvent, this)
                });
                this._coralEmbeded = true;
            }, this));
        },

        /**
         * Get current user info from GUP
         * @private
         * @returns {Deferred}
         */
        _getUserResponse: function () {
            if (!this.userUtil || this._loggedInViaEmbed) {
                this.userUtil = new UserUtil();
            }
            if (!this.userResponse || this._loggedInViaEmbed) {
                this.userResponse = this.userUtil.getUser();
            }
            return this.userResponse;
        },

        /**
         * Handles emitted events from the commenting service/iframe.
         * @private
         */
        _registerCommentingLoginEvent: function (events) {
            events.on('loginPrompt', _.bind(function() {
                this._redirectToLogin(true);
            }, this));
            events.on('signOut.success', _.bind(function() {
                this._logout();
            }, this));
        },

        /**
         * Handles messages from Commenting service, GUP or CM page.
         * @private
         */
        _onSafeFrameMsg: function (e) {
            if (e && e.origin === this._serviceUrl && e.data.indexOf('{') > -1) {
                // Message recieved originated from Coral Talk
                var eventData = JSON.parse(e.data.substr(e.data.indexOf('{')));

                if (eventData) {
                    if (eventData.method === 'getItem') {
                        var getItemKey = Utils.getNested(eventData.parameters, 'key') || '';
                        if (getItemKey.indexOf('replyCommentFormBody') > -1) {
                            // User tapped the Replies link
                            PubSub.trigger('uotrack', this._trackingPrefix + 'reaction|commentreply');

                            // The reply comment box automatically has focus so also fire the reply comment box focus event
                            PubSub.trigger('uotrack', this._trackingPrefix + 'accessreply|success');
                        }
                    } else if (eventData.eventName && eventData.eventName.indexOf('mutation') > -1) {
                        switch (eventData.eventName) {
                            case 'mutation.createComment':
                                // User posted a comment
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentpost|success');
                                this._addEngagement('postComment');
                                break;
                            case 'mutation.createCommentReply':
                                // User posted a comment reply
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentreplypost|success');
                                this._addEngagement('postComment');
                                break;
                            case 'mutation.createCommentReaction':
                                // User respected a comment
                                PubSub.trigger('uotrack', this._trackingPrefix + 'reaction|commentrespect');
                                break;
                            case 'mutation.createCommentFlag':
                                // User reported a comment with reason
                                if (eventData.value.reason === 'COMMENT_REPORTED_OFFENSIVE') {
                                    // User reported a comment as offensive
                                    PubSub.trigger('uotrack', this._trackingPrefix + 'commentreport|COMMENT_OFFENSIVE');
                                } else if (eventData.value.reason === 'COMMENT_REPORTED_SPAM') {
                                    // User reported a comment as spam
                                    PubSub.trigger('uotrack', this._trackingPrefix + 'commentreport|COMMENT_SPAM');
                                } else if (eventData.value.reason === 'COMMENT_REPORTED_OTHER') {
                                    // User reported a comment as other
                                    PubSub.trigger('uotrack', this._trackingPrefix + 'commentreport|COMMENT_OTHER');
                                }
                                break;
                            case 'mutation.createCommentDontAgree':
                                // User reported a comment with disagree
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentreport|dontagree');
                                break;
                            case 'mutation.rejectComment':
                                // An admin rejected a comment.
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentmod|denied');
                                break;
                            case 'mutation.approveComment':
                                // An admin approved a comment.
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentmod|approved');
                                break;
                        }
                    } else if (eventData.eventName === 'openSortMenu') {
                        // sort menu open
                        PubSub.trigger('uotrack', this._trackingPrefix + 'commentsortby|menuopen');
                    } else if (eventData.eventName === 'setCommentsOrderBy') {
                        switch (eventData.value.orderBy) {
                            case 'CREATED_AT_DESC':
                                // newest
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentsortby|newest');
                                break;
                            case 'CREATED_AT_ASC':
                                // oldest
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentsortby|oldest');
                                break;
                            case 'REPLIES_DESC':
                                // most replies
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentsortby|mostreplied');
                                break;
                            case 'REACTION_DESC':
                                // most respected
                                PubSub.trigger('uotrack', this._trackingPrefix + 'commentsortby|mostrespected');
                                break;
                        }
                    }
                }
            } else if (e && this._safeFrameOrigins.indexOf(e.origin) > -1) {
                if (e.data.flow === 'authenticate') {
                    switch (e.data.result) {
                        case 'success':
                            // User sucessfully logged in via gup embed. Reinitialize coral talk and give it the new user
                            this._loggedInViaEmbed = true;
                            this._initializeCoralTalk();
                            break;
                        case 'cancel':
                            // User cancelled out of gup embedded page
                            this._gupEmbed.attr('src', 'about:blank');
                            this._toggleCoralTalkAndGupEmbed();
                            break;
                    }
                } else if (e.data.flow === 'embeddedLogin' && e.data.result === 'authenticated') {
                    // Receiving this message from CMSP post-auth embed page, letting subscribers know the user was logged in.
                    // Set the logged in from embed flag so the comments embed will be initialized the next time it appears.
                    this._loggedInViaEmbed = true;
                }
            }
        },

        /**
         * This method is called when the user needs to log in or subscribe in order to post comments.
         * @param {String} fromActionLink
         * @private
         */
        _redirectToLogin: function (fromActionLink) {
            var source = fromActionLink ? 'accessreply' : 'accesscomments';
            var url;

            if (this.$user || this._loggedInViaEmbed) {
                // User is logged in but doesn't have market access. Redirect them to the subscribers only page
                PubSub.trigger('uotrack', this._trackingPrefix + source + '|lacksauthorization');

                url = this._cmPage + '/subscriber-only-access/' +
                    '?preauth=true&style=chromeless';
            } else {
                // User is not logged in.  Present the embedded gup login page
                PubSub.trigger('uotrack', this._trackingPrefix + source + '|login');

                if (this._config.REQUIRESMARKETACCESS) {
                    var onSuccessUrl = encodeURIComponent(this._cmPage + '/subscriber-only-access/?style=chromeless');

                    url = this._gupLogin + '/' + window.site_vars.site_code + '-' + this._config.GUPUAID +
                        '/authenticate/?bypass-returning-user=true&window-mode=embedded&success-url=' + onSuccessUrl;
                } else {
                    url = this._gupLogin + '/' + window.site_vars.site_code + '-' + this._config.GUPUAID +
                    '/authenticate/?bypass-returning-user=true&window-mode=embedded';
                }
            }

            if (url) {
                this._gupEmbed.attr('src', url);
                this._toggleCoralTalkAndGupEmbed();
            }
        },

        _logout: function () {
            // The user clicked the Sign out link.
            var logoutUrl = Utils.getNested(window.site_vars, 'userAuthentication', 'logout', 'url');

            this._gupEmbed.attr('src', logoutUrl);

            this.$user = null;

            PubSub.trigger.apply(PubSub, ['user:statuschange', 'firefly', 'loggedOut', null]);
        },

        _addEngagement: function(key, value) {
            var coralTalkEngagement = JSON.parse(window.localStorage.getItem('coralTalkEngagement') || '{}');

            coralTalkEngagement.lastUpdated = new Date().getTime();
            // If no value is specified then give it the lastUpdated's timestamp
            coralTalkEngagement[key] = value ? value : coralTalkEngagement.lastUpdated;

            window.localStorage.setItem('coralTalkEngagement', JSON.stringify(coralTalkEngagement));
        },

        /**
         * Toggles the coral talk and gup login components and scrolls to the top
         * @private
         */
        _toggleCoralTalkAndGupEmbed: function() {
            this._coralTalkHeader.toggleClass('hidden');
            this._coralTalkEmbedWrap.toggleClass('hidden');
            this._gupEmbed.toggleClass('hidden');
            this._scrollWrapComments.scrollTop(0);

            this._commentsEmbedHidden = this._coralTalkEmbedWrap.hasClass('hidden');
        },

        /**
         * Listens for events posted by coral talk or gup.
         * @public
         */
        attachEventListener: function () {
            if (this._loggedInViaEmbed || (this._coralEmbeded && this._coralTalkEmbed.html() === '')) {
                // The user has logged in from the embed but hasn't returned from the CMSP page.
                this._initializeCoralTalk();
            } else if (this._commentsEmbedHidden) {
                // Show coral talk components and hide the gup embed
                this._toggleCoralTalkAndGupEmbed();
            }

            // Listen for messages sent from Coral Talk's Comments service
            window.addEventListener("message", this._onSafeFrameMsg, false);

            // Append the following QSP to the current story url so the comments will automatically open if/when
            //   the user refreshes the page
            if (window.location.href.toLowerCase().indexOf('open-comments=true') === -1) {
                var separator = window.location.href.indexOf('?') === -1 ? '?' : '&';
                var storyUrl = window.location.href + separator + 'open-comments=true';
                window.history.pushState('', '', storyUrl);
            }

            this._addEngagement('openComments');
        },

        /**
         * Removes listener created to handle events posted by coral talk or gup.
         * @public
         */
        unattachEventListener: function () {
            this._gupEmbed.attr('src', '');
            window.removeEventListener("message", this._onSafeFrameMsg, false);

            // remove the open-comments QSP that was created when the comments flyout was opened.
            var storyUrl = window.location.href
                .replace(new RegExp('[?&]open-comments=[^&#]*(#.*)?$'), '')
                .replace(new RegExp('([?&])open-comments=[^&]*&'), '');
            window.history.pushState('', '', storyUrl);
        }
    });

    return new CoralTalk();
});

